import * as React from "react";
import styled, { css, useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { NoSearchResult } from "components/common";
import GenericPlot from "views/components/visualizations/GenericPlot";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import useDisplayName from "ai-management/token-usage/hooks/useDisplayName";
import UsageSection from "ai-management/token-usage/UsageSection";
import { GROUPINGS } from "ai-management/token-usage/breakdown";
import { toSlices } from "ai-management/token-usage/charts";
const ChartArea = styled.div(
  ({ theme }) => css`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: center;
    min-height: 160px;

    @media (max-width: ${theme.breakpoints.max.md}) {
      flex: none;
      height: 240px;
    }
  `
);
const ChartContainer = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  max-height: 250px;
`;
const layout = { showlegend: false, margin: { t: 0, r: 0, b: 0, l: 0 } };
const TokenShareChart = ({ usage, grouping, colors }) => {
  const { t } = useTranslation("enterprise_ai");
  const theme = useTheme();
  const displayName = useDisplayName();
  const { detail } = GROUPINGS[grouping];
  const slices = toSlices(usage.rows, grouping);
  const sliceName = ({ group }) => displayName(group);
  const chartData = [
    {
      type: "pie",
      labels: slices.map(sliceName),
      values: slices.map(({ totalTokens }) => totalTokens),
      marker: {
        colors: slices.map(({ key }) => colors.get(key)),
        line: { color: theme.colors.global.contentBackground, width: 1 }
      },
      hole: 0.35,
      sort: false,
      textinfo: "percent",
      // Labels of small slices are placed outside, on the background.
      outsidetextfont: { color: theme.colors.text.primary },
      hovertemplate: "%{label}<br>%{value:,} tokens<br>%{percent}<extra></extra>",
      automargin: true
    }
  ];
  return /* @__PURE__ */ React.createElement(UsageSection, { title: t("token_share_chart.title"), detail: t(detail) }, slices.length === 0 ? /* @__PURE__ */ React.createElement(NoSearchResult, null, t("token_usage.no_token_usage")) : /* @__PURE__ */ React.createElement(ChartArea, null, /* @__PURE__ */ React.createElement(ChartContainer, null, /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: "read-only" }, /* @__PURE__ */ React.createElement(GenericPlot, { chartData, layout })))));
};
export default TokenShareChart;
